export const rows = [
    { property: 'daysDifference', label: 'SMOOVED_ANALYTICS.DETAILS.INPUTS.AVG_DAYS' },
    { property: 'priorPercent', label: 'SMOOVED_ANALYTICS.DETAILS.INPUTS.AVG_PRIOR_MOVING' },
    { property: 'afterPercent', label: 'SMOOVED_ANALYTICS.DETAILS.INPUTS.AVG_AFTER_MOVING' },
];
